// EnhancedTableRow.js
import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';

function EnhancedTableRow({ row, isSelected, labelId, handleClick, isDisabled  }) {
  return (
    <TableRow
      hover
      onClick={(event) => {
        if (!isDisabled) {
          handleClick(event, row)
        }
      }}
      role="checkbox"
      aria-checked={isSelected}
      tabIndex={-1}
      key={row.id}
      selected={isSelected}
      sx={{ cursor: 'pointer' }}
    >
      <TableCell padding="checkbox">
        <Checkbox
          checked={isSelected}
          inputProps={{
            'aria-labelledby': labelId,
          }}
          disabled={isDisabled}
        />
      </TableCell>
      <TableCell component="th" id={labelId} scope="row" padding="none">
        {row.user_nm}
      </TableCell>
      <TableCell align="left">{row.departs_nm}</TableCell>
    </TableRow>
  );
}

export default EnhancedTableRow;
